// TODO: Descomentar solo cuando se cree la store
// import {mapGetters} from 'vuex/dist/vuex.common.js'

// TODO: No esta implementado el mixing
// import cardMixin from 'js/pages/municipality-data/balance/cards/_card-data.js'
import genericSvgIcon from 'js/components/_moverick/generic-svg-icon'

import card from 'js/components/journeys/cards/card'
import template from './index.pug'

export default Vue.extend({
  name: 'card-tab',
  template: template(),
  components: {genericSvgIcon, card},

  data() {
    return {
      parentItem: '',
      childItem: []
    }
  },
  computed: {
    // TODO: Store no creado aún
    // ...mapGetters('user', ['cards'])
  }
})
